module.exports = __webpack_public_path__ + "static/img/3.647606b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mentmo/4/3.png
// module id = snRn
// module chunks = 0